export default __webpack_public_path__ + "static/media/AnalyticsIcon.db946dc8.svg";